"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModalFooterCtx = exports.ModalFooter = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var rc_dialog_1 = tslib_1.__importDefault(require("rc-dialog"));
var Footer_1 = tslib_1.__importStar(require("./Footer"));
exports.ModalFooter = Footer_1.default;
Object.defineProperty(exports, "useModalFooterCtx", { enumerable: true, get: function () { return Footer_1.useFooterCtx; } });
var ConfigProvider_1 = require("../ConfigProvider");
var Mask_1 = tslib_1.__importDefault(require("../internal/Mask"));
var hooks_1 = require("./hooks");
function Modal(props) {
    var prefix = ConfigProvider_1.usePrefix('modal');
    var _a = hooks_1.useModalProps(props, prefix), maskProps = _a.maskProps, rcDialogProps = _a.rcDialogProps;
    return (react_1.default.createElement(Mask_1.default, tslib_1.__assign({}, maskProps),
        react_1.default.createElement(rc_dialog_1.default, tslib_1.__assign({}, rcDialogProps))));
}
exports.default = Modal;
//# sourceMappingURL=index.js.map